import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import decode from 'jwt-decode';
import { SupervisedUserCircle } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import { getRoles, refreshToken as doRefreshToken } from 'actions/Auth';
import Button from 'components/CustomButtons/Button';
import { isEmpty, isGranted } from 'helpers/helpers';
import { ROLE_IMPERSONATE_USER } from 'helpers/roles';

const useStyles = makeStyles({
  icon: {
    margin: '0 0 0 0.5rem',
    padding: '0',
    width: '20px',
  },
});

const FakeUserIcon = ({
  domain,
  mainDomain,
  email,
  token,
  // eslint-disable-next-line no-shadow -- FIXME
  getRoles,
  refreshToken,
  // eslint-disable-next-line no-shadow -- FIXME
  doRefreshToken,
}) => {
  const redirectDomain = domain ?? mainDomain;
  const classes = useStyles();

  if (!isGranted(ROLE_IMPERSONATE_USER) || isEmpty(redirectDomain)) {
    return null;
  }

  const handleImpersonate = async () => {
    const { exp } = decode(token);

    const openSwitchPage = switchToken => {
      window.open(
        `https://${redirectDomain}/auth/switch?token=${switchToken}&refreshToken=${refreshToken}&email=${encodeURIComponent(
          email
        )}`,
        '_blank'
      );
    };

    // EXP is in seconds, so we convert it to milliseconds and remove 60000ms (1min)
    if (Date.now() >= exp * 1000 - 60000) {
      const newToken = await doRefreshToken();
      await getRoles();

      openSwitchPage(newToken);

      return;
    }

    openSwitchPage(token);
  };

  return (
    <Button
      simple={true}
      round={true}
      color="primary"
      className={classes.icon}
      onClick={handleImpersonate}
    >
      <SupervisedUserCircle />
    </Button>
  );
};

const mapStateToProps = ({
  Brands: { brand },
  Auth: { token, refreshToken, selectedBrand },
}) => ({
  mainDomain: brand.mainDomain || '',
  refreshToken,
  selectedBrand,
  token,
});

const mapDispatchToProps = { doRefreshToken, getRoles };

FakeUserIcon.propTypes = {
  domain: PropTypes.string,
  mainDomain: PropTypes.string,
  email: PropTypes.string.isRequired,
  refreshToken: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(FakeUserIcon);
